export default "__VITE_ASSET__CufDBFYx__"